export default __webpack_public_path__ + "static/media/12.3.1a.a3a09c9a.pdf";